export default __webpack_public_path__ + "static/hp-hero-7fceb762b1d7c7145b9af2ab2a4212ca.webp";